export default function index(message) {
  if (process.env.NODE_ENV === "development") {
    console.log(message);
  }
}
